import { connect } from 'react-redux';

import { createKkm } from '@/features/kkmCreatePage/actions';

import NewKkm from './component';

const mapDispatchToProps = { createKkm };

export default connect(null, mapDispatchToProps)(NewKkm);
